export const VUE_ROOT_APP_SYMBOL = Symbol("vueRootApp");
export const LAYOUTS_SYMBOL = Symbol("layouts");
export const VUE_I18N_SYMBOL = Symbol("vueI18n");
export const PC_RES_SYMBOL = Symbol("pcRes");
export const PAGE_APP_SYMBOL = Symbol("pcPageApp");
export const LOC_PAGE_NAME_SYMBOL = Symbol("LocalizedPageName");
export const EMBED_APP_SYMBOL = Symbol("pcEmbedApp");
export const AWS_RUM_SYMBOL = Symbol("awsRum");
